import { useEffect, useRef } from 'react';
import { usePathname } from 'next/navigation';
import { logPageView, setLocation } from '@cbhq/client-analytics';
import { DEFAULT_PAGE_KEY_REGEX } from '@/app/utils/analytics/pageKeyRegex';
import { getIsLocalDev } from '@/app/utils/analytics/events';

export function useLogPageViews() {
  const previousPath = useRef<string>();
  const pathname = usePathname();
  useEffect(() => {
    if (getIsLocalDev()) {
      return;
    }

    if (pathname !== previousPath.current) {
      setLocation({
        pageKeyRegex: DEFAULT_PAGE_KEY_REGEX,
      });

      logPageView();
    }

    previousPath.current = pathname;
  }, [pathname]);
}
